import React from "react";
import { ClickAwayListener, MenuList } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { makeStyles } from "@material-ui/core/styles";

const OptionsMenu = ({
  anchor,
  isReadOnlyUser,
  open,
  setEditOpen,
  setCloneOpen,
  setDeleteOpen,
  setViewOpen,
  onClose,
}) => {
  const classes = useStyles();

  const handleViewSOE = () => {
    setViewOpen(true);
    onClose();
  };

  const handleEditSOE = () => {
    setEditOpen(true);
    onClose();
  };
  const handleCloneSOE = () => {
    setCloneOpen(true);
    onClose();
  };

  const handleDeleteSOE = () => {
    setDeleteOpen(true);
    onClose();
  };

  return (
    <Popper
      open={open}
      anchorEl={anchor}
      placement="bottom-end"
    >
      <Paper classes={classes}>
        <ClickAwayListener onClickAway={onClose}>
          <MenuList
            autoFocusItem={open}
            id="composition-menu"
            aria-labelledby="composition-button"
          >
            {isReadOnlyUser ? (
              <MenuItem onClick={handleViewSOE}>View SOE</MenuItem>
            ) : (
              <>
                <MenuItem onClick={handleEditSOE}>Edit SOE</MenuItem>
                <MenuItem onClick={handleCloneSOE}>Clone SOE</MenuItem>
                <MenuItem onClick={handleDeleteSOE}>Delete SOE</MenuItem>
              </>
            )}
          </MenuList>
        </ClickAwayListener>
      </Paper>
    </Popper>
  );
};

export default OptionsMenu;

const useStyles = makeStyles((theme) => ({
  root: {
    background: "var(--White)",
    border: "1px solid var(--surface-200)",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.22)",
    borderRadius: "4px",
    padding: "0",
  },
}));
